import request from '@/utils/request'
//系统名称
export const getSystemInfo = () => request.get('/official/home/logo')
//首页banner
export const getBannerList = (sector) => request.get(`/official/home/banner/${sector}`)
//咨询顾问
export const getTeamList = () => request.get(`/official/home/consultTeam`)
//咨询顾问-详情
export const getTeamDetails = (id) => request.get(`/official/home/consultTeam/${id}`)
//全案咨询
export const getConsultationList = () => request.get(`/official/home/caseConsultation`)
//客户案例
export const getCustomerCaseList = (id) => request.get(`/official/home/customerCase?id=${id}`)
//在线申请
export const apply = (data) => request.post(`/official/home/apply`,data)
//获取菜单
export const getMenuList = () => request.get(`/official/website/menu`)

